import Param from '../param';

const param = new Param();

export default class faqManager {
    constructor() {
      /* 必要なDOM */
      this.selectTrigger = document.querySelectorAll('.c-input__select select');
      this.selectContent = document.querySelectorAll('.c-input__select__label');
      this.spTabTrigger = document.querySelectorAll('.p-faq-tab_sp select');
      this.tabTrigger = document.querySelectorAll('.js__tab');


      this.contentTrigger = document.querySelectorAll('.faq-input__select select');
      this.contentContent = document.querySelectorAll('.p-faq-content');
      this.contentTarget = 0;
      this.target = 0;
      this._isRestore = false

      TweenMax.set(this.contentContent[0],{
          display:'block',
          opacity:1
      });

      // 前回のアクティブセクション、またはURLパラメーターの処理
      var _prevParam = sessionStorage.getItem('faqPrevParam');
      var _param = this.getParam('select') || this.getParam('category');
      var _id
      if (_param === _prevParam) {
        // 戻るボタン等で戻ってきたとき
        this._isRestore = true
        _id = sessionStorage.getItem('faqSection');
        if (!_id) {
          _id = _param
        }
      } else {
        // 初期表示時
        this._isRestore = false
        _id = _param
      }
      switch (_id) {
        case 'ricepot':
          this.selectTrigger[0].getElementsByTagName('option')[1].selected = true;
          this.contentChange(0);
          break;
        case 'fryingpan':
          this.selectTrigger[0].getElementsByTagName('option')[2].selected = true;
          this.contentChange(0);
          break;
        case 'app':
          this.selectTrigger[0].getElementsByTagName('option')[3].selected = true;
          this.contentChange(0);
          break;
        case 'other':
          this.selectTrigger[0].getElementsByTagName('option')[4].selected = true;
          this.contentChange(0);
          break;
      }
      if (_param) {
        sessionStorage.setItem('faqPrevParam', _param);
      }
    }
    init(){

        let _this = this;

        //セレクトボックス変更時の内部テキスト更新
        let _selectLength = this.selectTrigger.length;

        for(var i = 0 ; i < _selectLength ; i++){
          (function(arg) {
            _this.selectChange(arg);
            _this.selectTrigger[i].addEventListener('change', function() {
              _this.selectChange(arg);
            }, false);
          })(i);
        }

        //SP側、タブに相当するセレクトボックス変更時のページ内スクロール
        let _spTabLength = this.spTabTrigger.length;
        for(var i = 0 ; i < _spTabLength; i++){
          (function(arg2) {
            _this.spTabTrigger[i].addEventListener('change', function() {
              //setTimeout(_this.spTabChange,2500,arg2,_this);
              _this.spTabChange(arg2);
            }, false);
          })(i);
        }

        //PC側・タブクリック時のタブへのis-active切り替え（共通jsのmodule/tab/managerにて未実装のため？）
        let _tabLength = this.tabTrigger.length;
        for(var i = 0 ; i < _tabLength; i++){
          (function(arg3) {
            _this.tabTrigger[i].addEventListener('click', function() {
              Array.from(_this.tabTrigger, e =>{e.classList.remove("is-active")})
              _this.tabTrigger[arg3].classList.add("is-active");
              sessionStorage.setItem('faqTab', arg3);
            }, false);
          })(i);
        }
        // 前回のアクティブタブがあればそのタブを表示する
        if (_this._isRestore && _this.tabTrigger[sessionStorage.getItem('faqTab')]) {
          var _tabTrigger = _this.tabTrigger[sessionStorage.getItem('faqTab')];
          if(param.browserType === 'IE'){
            let event = document.createEvent('Event');
            event.initEvent('click', true, true);
            _tabTrigger.dispatchEvent(event);
          }else {
            _tabTrigger.dispatchEvent(new Event('click'));//IE非対応
          }
        }

         //上部内容選択セレクトボックス変更時のコンテンツ切り替え
        let _contentLength = this.contentTrigger.length;
        for(var i = 0 ; i < _contentLength; i++){
          (function(arg4) {
            _this.contentTrigger[i].addEventListener('change', function() {
              _this.contentChange(arg4);

              var _id = _this.getId(_this.contentTrigger[arg4].selectedIndex);
              if (_id) {
                sessionStorage.setItem('faqSection', _id)
                // _this.setParam('select', _id);
              }
            }, false);
          })(i);
        }


    }

    selectChange(number){ //セレクトボックス変更時の内部テキスト更新

      let _this = this;

      let _value = this.selectTrigger[number].value;
      // console.log(number, this.selectTrigger[number], _value, document.querySelector('option[value="'+_value+'"]'));
      let _optionText = document.querySelector('option[value="'+_value+'"]').textContent;
      // console.log(_optionText);
      this.selectContent[number].textContent = _optionText;

    }

    spTabChange(number){ //SP側、タブに相当するセレクトボックス変更時のページ内スクロール
        if(param.userAgent === 'sp'){
            let _this = this;
            // let _html = document.querySelector('html');
            // _html.style.setProperty('-webkit-overflow-scrolling', 'auto');
            // document.body.style.setProperty('-webkit-overflow-scrolling', 'auto');

            let _value = _this.spTabTrigger[number].value;
            let _target = document.querySelector(_value);
            let rect = _this.getAbsolutePosition(_target);
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let headerHeight = document.getElementById('l-header').offsetHeight;
            let myTop = rect.top  - headerHeight;
            TweenLite.to(window, .5, {scrollTo:{y:myTop,autoKill:false},onComplete: function(){
                    // location.hash = _value;
                    // return false;
                }});
        }
    }

    contentChange(number) { //上部内容選択セレクトボックス変更時のコンテンツ切り替え

        let _this = this;
        let _value = this.contentTrigger[number].value;
        let _target = document.querySelector(_value);

        //PC側、遷移先のコンテンツの最初のタブをクリックしたことにする処理
        let _tab = _target.querySelectorAll('.js__tab')[0];

        if(param.browserType === 'IE'){
            let event = document.createEvent('Event');
            event.initEvent('click', true, true);
            _tab.dispatchEvent(event);
        }else {
            _tab.dispatchEvent(new Event('click'));//IE非対応
        }
        TweenMax.to(this.contentContent, 0.3 ,{
            alpha: 0,
            ease : Power2.easeOut,
            onComplete:function(){
                TweenMax.set(_this.contentContent, {
                    display: 'none',
                });
                TweenMax.set(_target, {
                    display: 'block',
                    onComplete:function(){
                        TweenMax.to(_this.contentContent, 0.3 , {
                            alpha: 1,
                            ease : Power2.easeIn,
                            onComplete:function(){
                                if(param.browserType === 'IE'){
                                    let event = document.createEvent('Event');
                                    event.initEvent('resize', true, true);
                                    window.dispatchEvent(event);
                                }else {
                                    window.dispatchEvent(new Event('resize')); //スムーススクロールのl-rootの高さ再取得のためリサイズイベントを走らせる
                                }
                            }
                        });
                    }
                });
            }
        });

    }

    getAbsolutePosition(elm){
      const {left, top} = elm.getBoundingClientRect();
      const {left: bleft, top: btop} = document.body.getBoundingClientRect();
      return {
        left: left - bleft,
        top: top - btop,
      };
    }

    getParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    getId(index) {
      switch (index) {
        case 0:
          return 'ovenpotround';
        case 1:
          return 'ricepot';
        case 2:
          return 'fryingpan';
        case 3:
          return 'app';
        case 4:
          return 'other';
        default:
          return;
      }
    }

    setParam(name, value) {
        var resurl = window.location.href.replace(/\?.*$/,"");
        window.history.pushState(null, '', resurl + '?' + name + '=' + value)
    }

}
